import React from 'react';
import { DynamicObject } from '../../utils/commonTypes';
import { useAppStore } from '../../hooks/useAppStore';

interface GameLogoProps {
  extendedStyles: DynamicObject;
}

const GameLogo: React.FC<GameLogoProps> = ({ extendedStyles }) => {
  const { gamificationState = {} } = useAppStore();
  const { config = null } = gamificationState;
  return (
    <img
      src={config?.quizTitleImage}
      css={[extendedStyles]}
      alt={config?.quizPageTitle}
    />
  );
};

export default GameLogo;
